<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="10">
                    <h3>Cadastro de Usuário</h3>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
             <b-form v-on:submit.prevent="onSubmit">
                <b-alert v-if="alerta_pre_cadastro" show variant="warning">{{mensagem_pre_cadastro}}</b-alert>
                <b-row>
              <b-col cols="6">
                <b-form-group label="CPF:" id="fieldset-1" label-for="input-1">
                  <b-input-group class="mb-6">
                    <b-form-input
                                  id="input-1"
                                  aria-label="Campo de CPF"
                                  v-mask="'###.###.###-##'"
                                  type="text"
                                  class="form-control"
                                  placeholder="CPF"
                                  autocomplete="cpf"
                                  v-model="$v.form.cpf.$model"
                                  :state="chkState('cpf')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback1">CPF é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Nome:" id="fieldset-2" label-for="input-2">
                  <b-input-group class="mb-3">
                    <b-form-input
                                  id="input-2"
                                  type="text"
                                  aria-label="Nome"
                                  class="form-control"
                                  placeholder="Nome"
                                  autocomplete="nome"
                                  v-model.trim="$v.form.nome.$model"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
                <b-row>
              <b-col cols="6">
                <b-form-group label="E-mail:" id="fieldset-3" label-for="input-3">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  id="input-3"
                                  class="form-control"
                                  aria-label="E-mail"
                                  placeholder="E-mail"
                                  autocomplete="email"
                                  v-model.trim="$v.form.email.$model"
                                  :state="chkState('email')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Este é um campo obrigatório, e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Confirme o e-mail:" id="fieldset-4" label-for="confirmar-email">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  id="confirmar-email"
                                  placeholder="Confirme o e-mail"
                                  aria-label="Confirma e-mail"
                                  oncut="return false"
                                  onpaste="return false"
                                  autocomplete="confirme-email"
                                  v-model.trim="$v.form.confirmaEmail.$model"
                                  :state="chkState('confirmaEmail')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback8">Este é um campo obrigatório, e deve ser correspondente ao campo e-mail.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
                <b-row>
              <b-col cols="6">
                <b-form-group label="Tipo de Usuário:" id="fieldset-7" label-for="input-7">
                  <b-form-select v-model.trim="$v.form.tipoUsuario.$model" :state="chkState('tipoUsuario')" id="input-7" aria-label="Tipo de Usuário"
                                 placeholder="Tipo de Usuário" class="mb-3">
                    <option v-for="item in listacombo" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback9">Este é um campo obrigatório, e deve ser um endereço
                    de e-mail válido.
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                    <b-form-group label="Status:">
                        <b-form-radio-group v-model="$v.form.status.$model" :state="chkState('status')" id="radio-slots" :options="options" name="radio-options-slots"/>
                    </b-form-group>
                 </b-col>
            </b-row>
                <b-row>
              <b-col cols="6">
                <b-form-group label="Senha:" id="fieldset-5" label-for="input-5">
                  <b-input-group class="mb-3">
                    <b-form-input type="password" class="form-control" placeholder="Senha" id="input-5" aria-label="Senha"
                                  v-model.trim="$v.form.senha.$model" :state="chkState('senha')"
                                  autocomplete="new-password"/>
                    <b-form-invalid-feedback id="input1LiveFeedback10">Este é um campo obrigatório, e precisa ter no mínimo 6 dígitos.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Confirmar a Senha:" id="fieldset-6" label-for="input-6">
                  <b-input-group class="mb-4">
                    <b-form-input type="password" class="form-control" placeholder="Confirmar a Senha" id="input-6" aria-label="Confirmar Senha"
                                  v-model.trim="$v.form.confirmaSenha.$model" :state="chkState('confirmaSenha')"
                                  autocomplete="new-password"/>
                    <b-form-invalid-feedback id="input1LiveFeedback11">Este é um campo obrigatório, e as senhas devem corresponder.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
             </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="3" offset-md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Criar Usuário</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, minLength, email, sameAs} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'

miniToastr.init()

const formShape = {
  cpf: '',
  nome: '',
  tipoUsuario: 2,
  email: '',
  senha: '',
  confirmaSenha: '',
  confirmaEmail: '',
  status: true
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      cpf: {
        required,
        minLength: minLength(14)
      },
      nome: {
        required
      },
      email: {
        required,
        email
      },
      confirmaEmail: {
        required,
        email,
        sameAsEmail: sameAs('email')
      },
      tipoUsuario: {
        required
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      confirmaSenha: {
        required,
        sameAsSenha: sameAs('senha')
      },
      status: {
        required
      }
    }
  },
  created () {
    this.$store.dispatch('buscarTipoUsuarios')
  },
  data () {
    return {
      salvarForm: false,
      form: Object.assign({}, formShape),
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      options: [
        { text: 'Ativo', value: true },
        { text: 'Inativo', value: false }
      ],
      alerta_pre_cadastro: false,
      mensagem_pre_cadastro: ''
    }
  },
  computed: {
    listacombo () {
      return this.$store.getters.getListaCombo
    },
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    salvar () {
      let form = this.$v.form
      let data = {
        cpf: form.cpf.$model.replace(/[^\d]+/g, ''),
        nome: form.nome.$model,
        email: form.email.$model,
        email_confirmation: form.confirmaEmail.$model,
        password: form.senha.$model,
        password_confirmation: form.confirmaSenha.$model,
        perfis: JSON.stringify([{ id: form.tipoUsuario.$model }]),
        ativo: form.status.$model
      }

      // this.disable_buttons = true

      Vue.http.post('api/usuario', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/usuarios'})
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        let response = e.body.data
        if (response) {
          for (let erro of response) {
            miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
            miniToastr.error(erro, 'Erro!', 5000)
          }
        }
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true

      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]

      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/UsuarioCadastrar.vue